import { render, staticRenderFns } from "./select.vue?vue&type=template&id=0dca35de&scoped=true"
import script from "./select.js?vue&type=script&lang=js&external"
export * from "./select.js?vue&type=script&lang=js&external"
import style0 from "./select.scss?vue&type=style&index=0&id=0dca35de&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca35de",
  null
  
)

export default component.exports